module.exports = __webpack_public_path__ + "static/media/Logos.dff9e5a3.png";